import { ReactElement } from 'react';
import { Modal } from '@weareopenr/component-library';

export interface IModalWrapper {
  closeModal?: () => void;
  open: boolean;
  children: ReactElement;
  image: string;
  imageAlt: string;
}

export const ModalWrapper = ({ closeModal, open, children, image, imageAlt }: IModalWrapper): ReactElement => {
  return (
    <Modal open={open} closeModal={closeModal} image={image} imageAlt={imageAlt}>
      {children}
    </Modal>
  );
};
